import PropTypes from 'prop-types';
import { useLayoutEffect } from 'react';
import { useFloatingEditorState } from '../hooks/useFloatingEditorState';
import { AsyncComposeEditor } from './AsyncComposeEditor';
import { FloatingComposeEditorWrapper } from './FloatingComposeEditorWrapper';
import { usePopOutEditorState, usePopOut } from '../../../pop-out/public/hooks';
import { EditorModal } from '../../../pop-out/public/components';
import { FloatingContainer } from './ClassicFloatingComposeEditor';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const teleportOptions = {
  elementConstructor() {
    const e = document.createElement('div');
    e.classList.add('popout-editor-teleporter');
    e.style.setProperty('width', '100%');
    return e;
  }
};
export const PopOutComposeEditor = ({
  associations,
  onSend = () => {},
  inboxId,
  renderExistingFileSelect,
  useWhatsAppCompose,
  defaultMessageValue
}) => {
  const {
    isOpen,
    close
  } = useFloatingEditorState();
  const {
    isOpen: isExpanded,
    ref
  } = usePopOutEditorState('floating');
  const component = /*#__PURE__*/_jsx(AsyncComposeEditor, {
    associations: associations,
    onClose: close,
    onSend: onSend,
    onSendStart: close,
    inboxId: inboxId,
    useWhatsAppCompose: useWhatsAppCompose,
    renderExistingFileSelect: renderExistingFileSelect,
    StyledWrapper: FloatingComposeEditorWrapper,
    defaultMessageValue: defaultMessageValue
  }, 'async-editor-floating');
  const [portal, popOut, reset] = usePopOut(component, teleportOptions);
  useLayoutEffect(() => {
    if (isExpanded && ref) {
      popOut(ref);
    } else {
      reset();
    }
  }, [isOpen, isExpanded, ref, popOut, reset]);
  if (isOpen) {
    return /*#__PURE__*/_jsxs(FloatingContainer, {
      children: [/*#__PURE__*/_jsxs(Flex, {
        paddingInline: "400",
        children: [portal, " "]
      }), /*#__PURE__*/_jsx(EditorModal, {
        editorKey: "floating"
      })]
    });
  }
  return null;
};
PopOutComposeEditor.displayName = 'PopOutComposeEditor';
PopOutComposeEditor.propTypes = {
  inboxId: PropTypes.number.isRequired,
  onSend: PropTypes.func,
  renderExistingFileSelect: PropTypes.func,
  useWhatsAppCompose: PropTypes.bool
};